module.exports = __webpack_public_path__ + "img/w42.34e286a0.svg";